import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Discovery & Scoping",
    body: "We map your regulatory obligations, timelines and quality gaps in a structured intake session.",
  },
  {
    n: "02",
    title: "Qualification & Design",
    body: "For sourcing: vendor shortlist & DMF review. For compliance: protocol, SOP and audit plan design.",
  },
  {
    n: "03",
    title: "Execution",
    body: "On-site audits, cGMP readiness, sample dispatch, HPLC/GC testing and documentation — traceable end-to-end.",
  },
  {
    n: "04",
    title: "Reporting & Follow-through",
    body: "Regulator-ready reports, CAPA support, batch release documentation and continuous improvement roadmap.",
  },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="bg-slate-900 text-slate-100 py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="eyebrow mb-4" style={{ color: "#5EEAD4" }}>
            How We Work
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white leading-tight">
            A methodical process, delivered without drama.
          </h2>
          <p className="mt-6 text-slate-300 text-lg leading-relaxed">
            Every project runs through the same disciplined workflow — so you know what to expect, and regulators know
            what to trust.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-4">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={`process-step-${s.n}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className="relative p-8 border border-slate-800 hover:border-teal-400 transition-colors bg-slate-900/60"
            >
              <div className="font-display text-5xl font-semibold text-teal-400/80">{s.n}</div>
              <h3 className="mt-6 font-display text-xl font-semibold text-white">{s.title}</h3>
              <p className="mt-3 text-slate-400 leading-relaxed text-sm">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
